import { parseOpenFoodFacts } from '@domain/product'
import type { ProductLookup } from '@domain/ports/product-lookup'

/**
 * A busca no **Open Food Facts**.
 *
 * ## Direto do navegador, e isso foi medido antes de escolher
 *
 * A API responde `access-control-allow-origin: *`, então não precisa de Cloud
 * Function no meio. E não passar por uma é melhor: a `bootstrapHousehold` já
 * mostrou (decisão 58) que uma callable fria custa segundos, e segundos numa
 * conveniência de preencher formulário são a diferença entre usar e não usar.
 *
 * Também não há credencial a proteger — a base é aberta.
 *
 * ## `X-User-Agent`, porque navegador não define `User-Agent`
 *
 * A política deles pede que o app se identifique. `User-Agent` é header proibido
 * no `fetch`, e eles sabem disso: a resposta do preflight lista `X-User-Agent`
 * entre os aceitos. É a saída oficial deles, conferida na resposta real.
 *
 * ## Pede só os campos que usa
 *
 * O documento completo de um produto do OFF passa de 100 KB — nutrientes, selos,
 * histórico de edição, imagens em cinco tamanhos. `fields=` corta isso para
 * poucos bytes, o que importa num celular no corredor do mercado.
 */

const BASE = 'https://world.openfoodfacts.org/api/v2/product'
const CAMPOS = 'product_name,brands,product_quantity,product_quantity_unit,image_url'

export function createOpenFoodFactsLookup(fetchImpl: typeof fetch = fetch): ProductLookup {
  return {
    byGtin: async (gtin) => {
      const resposta = await fetchImpl(`${BASE}/${gtin}.json?fields=${CAMPOS}`, {
        headers: { 'X-User-Agent': 'Porquinho/1.0 (app doméstico privado)' },
      })

      // **404 é "não tem", e não é falha.** A API responde 404 para código
      // desconhecido, e tratá-lo como erro faria a tela pedir "tente de novo"
      // para algo que nunca vai mudar tentando.
      if (resposta.status === 404) return null
      if (!resposta.ok) {
        throw new Error(`openfoodfacts ${String(resposta.status)}`)
      }

      // A validação é do domínio. Ver `lookup.ts`.
      return parseOpenFoodFacts(await resposta.json())
    },
  }
}
